import _axios from "..";

export const SupersetService = {
  getDashboard: async (id: string, filters: Object): Promise<string> =>
    (await _axios.post(`/superset/${id}`, filters)).data,
};

export default SupersetService;
